import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { MultiPointModalData, MultiPointTabs } from '../report-modal.service';

@Component({
  selector: 'app-multi-point-modal',
  templateUrl: './multi-point-modal.component.html',
  styleUrl: './multi-point-modal.component.scss',
  standalone: false,
})
export class MultiPointModalComponent implements OnInit {
  @Input() ifs: string;
  @Input() multiPointData: MultiPointModalData;

  @Output() dismiss = new EventEmitter();

  HcTab = MultiPointTabs.HC;
  HpTab = MultiPointTabs.HP;
  wellTab = MultiPointTabs.WELL;
  activeTab: MultiPointTabs;

  constructor(private readonly translate: IpoTranslatePipe) {}

  ngOnInit(): void {
    this.setInitalTab();
  }

  setInitalTab() {
    this.activeTab = this.multiPointData.tabs.includes(this.HcTab)
      ? this.HcTab
      : this.multiPointData.tabs[0];
  }

  closeModal() {
    this.dismiss.emit();
  }

  onActiveTabChanged(tab: MultiPointTabs) {
    this.activeTab = tab;
  }

  setModalHeader() {
    if (
      this.multiPointData.tabs.includes(this.HpTab) &&
      this.multiPointData.tabs.includes(this.HcTab)
    ) {
      return this.translate.transform('multiPointModal.header.household');
    }
    if (this.multiPointData.tabs.includes(this.HpTab)) {
      return this.translate.transform('multiPointModal.header.hp');
    }
    if (this.multiPointData.tabs.includes(this.HcTab)) {
      return this.translate.transform('multiPointModal.header.hc');
    }
    if (this.multiPointData.tabs.includes(this.wellTab)) {
      return this.translate.transform('multiPointModal.header.well');
    } else return 'MDU';
  }
}
